import type { CodeBidiWarningPluginOptions } from '@atlaskit/editor-plugin-code-bidi-warning';

export function codeBidiWarningPluginOptions(): CodeBidiWarningPluginOptions {
	return {
		appearance: 'full-page',
	};
}
